import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { tenantCostService } from '../../../services/TenantCostService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useTenantCostSettingsQuery(enabled: boolean) {
  const { user } = useAuth();

  return useQuery({
    queryKey: tenantQueryKeys.costSettings(),
    enabled: Boolean(user) && enabled,
    queryFn: () => tenantCostService.getCostSettings(),
  });
}
